

import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2"; // <-- Import SweetAlert2

function SourceCreate() {
  const [sourceName, setSourceName] = useState("");
  const [alternateUrl, setAlternateUrl] = useState("");
  const [playstoreUrl, setPlaystoreUrl] = useState("");
  const [appVersion, setAppVersion] = useState("");
  const [originalSourceName, setOriginalSourceName] = useState("");
  const [packageName, setPackageName] = useState("");



  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      supabase
        .from("source")
        .select("*")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            // Swal.fire("Error", "Failed to load source", "error");
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Failed to load source", // dynamic message
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              toast: true,
              background: "white",
              customClass: {
                popup: "shadow-lg rounded-md p-3",
              },
            });

            navigate("/source");
          } else {
            // setSourceName(data.source || "");
            setSourceName(data.source || "");
            // setOriginalSourceName(data.source || "");
            setOriginalSourceName((data.source || "").trim().toLowerCase());


            setAlternateUrl(data.alternate_url || "");
            setPlaystoreUrl(data.playstore_url || "");
            setAppVersion(data.app_version || "");
            setPackageName(data.package || "");

          }
        });
    }
  }, [id, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!sourceName.trim()) {
      // Swal.fire("Warning", "Please enter a source name", "warning");
      Swal.fire({
        position: "top-end", // top-right corner
        icon: "warning", // success, error, warning, info
        title: "Please enter a source name", // your message
        showConfirmButton: false, // no OK button
        timer: 3000, // auto close after 3 seconds
        timerProgressBar: true, // shows a progress bar
        toast: true, // makes it a toast
        background: "white", // optional, Tailwind prefers light bg
        customClass: {
          popup: "shadow-lg rounded-md p-3", // Tailwind classes
        },
      });
      return;
    }

    setLoading(true);


    const normalized = sourceName.trim().toLowerCase();

    // ✅ ADD MODE — strict duplicate check
    if (!id) {
      const { data: existing } = await supabase
        .from("source")
        .select("id")
        .ilike("source", normalized);

      if (existing && existing.length > 0) {
        setLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `"${sourceName}" already exists`,
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          background: "white",
        });
        return;
      }
    }

    // ✅ EDIT MODE
    if (id) {
      // If name changed, THEN check duplicates
      if (normalized !== originalSourceName.toLowerCase()) {
        const { data: existing } = await supabase
          .from("source")
          .select("id")
          .ilike("source", normalized)
          .neq("id", id); // 🔑 exclude self

        if (existing && existing.length > 0) {
          setLoading(false);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `"${sourceName}" already exists`,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
            background: "white",
          });
          return;
        }
      }
    }


    const payload = {
      source: sourceName.trim(),
      alternate_url: alternateUrl.trim(),
      playstore_url: playstoreUrl.trim(),
      app_version: appVersion.trim(),
      package: packageName.trim(), // ✅ NEW
    };

    try {
      if (id) {
        const { error } = await supabase.from("source").update(payload).eq("id", id);
        setLoading(false);
        if (error) {
          // Swal.fire("Error", "Failed to update source", "error");
          Swal.fire({
            position: "top-end", // top-right corner
            icon: "error", // success, error, warning, info
            title: "Failed to update source", // your message
            showConfirmButton: false, // no OK button
            timer: 3000, // auto close after 3 seconds
            timerProgressBar: true, // shows a progress bar
            toast: true, // makes it a toast
            background: "white", // optional, Tailwind prefers light bg
            customClass: {
              popup: "shadow-lg rounded-md p-3", // Tailwind classes
            },
          });
        } else {
          // Swal.fire("Success", "Source updated successfully", "success");
          Swal.fire({
            position: "top-end", // top-right corner
            icon: "success", // success, error, warning, info
            title: "Source updated successfully", // your message
            showConfirmButton: false, // no OK button
            timer: 3000, // auto close after 3 seconds
            timerProgressBar: true, // shows a progress bar
            toast: true, // makes it a toast
            background: "white", // optional, Tailwind prefers light bg
            customClass: {
              popup: "shadow-lg rounded-md p-3", // Tailwind classes
            },
          });

          navigate("/source");
        }
      } else {
        const { error } = await supabase.from("source").insert([payload]);
        setLoading(false);
        if (error) {
          // Swal.fire("Error", "Failed to add source", "error");
          Swal.fire({
            position: "top-end", // top-right corner
            icon: "error", // success, error, warning, info
            title: "Failed to add source", // your message
            showConfirmButton: false, // no OK button
            timer: 3000, // auto close after 3 seconds
            timerProgressBar: true, // shows a progress bar
            toast: true, // makes it a toast
            background: "white", // optional, Tailwind prefers light bg
            customClass: {
              popup: "shadow-lg rounded-md p-3", // Tailwind classes
            },
          });
        } else {
          // Swal.fire("Success", "Source added successfully", "success");
          Swal.fire({
            position: "top-end", // top-right corner
            icon: "success", // success, error, warning, info
            title: "Source added successfully", // your message
            showConfirmButton: false, // no OK button
            timer: 3000, // auto close after 3 seconds
            timerProgressBar: true, // shows a progress bar
            toast: true, // makes it a toast
            background: "white", // optional, Tailwind prefers light bg
            customClass: {
              popup: "shadow-lg rounded-md p-3", // Tailwind classes
            },
          });
          navigate("/source");
        }
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      setLoading(false);
      // Swal.fire("Error", "An unexpected error occurred", "error");
      Swal.fire({
        position: "top-end", // top-right corner
        icon: "error", // success, error, warning, info
        title: "An unexpected error occurred", // your message
        showConfirmButton: false, // no OK button
        timer: 3000, // auto close after 3 seconds
        timerProgressBar: true, // shows a progress bar
        toast: true, // makes it a toast
        background: "white", // optional, Tailwind prefers light bg
        customClass: {
          popup: "shadow-lg rounded-md p-3", // Tailwind classes
        },
      });
    }
  };

  return (
    <div className="h-screen flex flex-col p-4 bg-gray-50">
      <div className="mb-4">
        <Button variant="secondary" className="flex items-center gap-2 px-4 py-2" onClick={() => navigate(-1)}>
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form onSubmit={handleSave} className="space-y-4 border border-slate-300 bg-gray-100 p-6 rounded-md max-w-lg w-full">
          <h1 className="text-2xl font-semibold mb-4 text-center">{id ? "Edit Source" : "Add New Source"}</h1>

          <input
            type="text"
            value={sourceName}
            onChange={(e) => setSourceName(e.target.value)}
            placeholder="Enter source name"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            autoFocus
          />
          <input
            type="text"
            value={alternateUrl}
            onChange={(e) => setAlternateUrl(e.target.value)}
            placeholder="Alternate URL"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            value={playstoreUrl}
            onChange={(e) => setPlaystoreUrl(e.target.value)}
            placeholder="Playstore URL"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="text"
            value={appVersion}
            onChange={(e) => setAppVersion(e.target.value)}
            placeholder="App Version"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <input
            type="text"
            value={packageName}
            onChange={(e) => setPackageName(e.target.value)}
            placeholder="Package Name"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />


          <div className="flex justify-center gap-4">
            <Button variant="primary" type="submit" disabled={loading} className="px-6 py-2 text-sm font-semibold">
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>
            <Button variant="secondary" onClick={() => navigate("/source")} className="px-6 py-2 text-sm font-semibold">
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SourceCreate;
